import api from '../api'
const BaseUrl = '/academy/api/AdminCourse'
const skillUpIssuanceCertificate = {
  issuanceCertificateTable(params) {
    return api.post(`${BaseUrl}/CourseLicensePeopleTable`, params)
  },
  applyCertificate(params) {
    return api.post(`${BaseUrl}/ApplyLicense`, params)
  },
  downloadCertificate(params) {
    return api.post(`${BaseUrl}/GetCourseLicense`, params)
  },
  hasLicense(params) {
    return api.post(`${BaseUrl}/HasLicense`, params)
  },
}

export default skillUpIssuanceCertificate
